module.exports = __webpack_public_path__ + "static/img/record_local1.633f1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/record_local1.png
// module id = 922
// module chunks = 1